
export function images() {
    const className: string = 'object-fit-cover';

    const nodeList = Array.from(document.getElementsByClassName(className));
    const elements = [].slice.call(nodeList);

    for (const element of elements) {
        element.setAttribute('data-object-fit', 'cover');
    }

    (window as any).objectFitPolyfill();
}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./assets/modules/images.ts